/* Kontakt form: custom validation, intl-tel-input, async submit with a thank-you state */
(function () {
  var root = document.querySelector('[data-ac-contact]');
  if (!root) return;

  var form = root.querySelector('form');
  var fields = root.querySelector('[data-ac-contact-fields]');
  var thanks = root.querySelector('[data-ac-contact-thanks]');
  if (!form || !fields || !thanks) return;

  var submitBtn = fields.querySelector('[data-ac-contact-submit]');
  var honeypot = fields.querySelector('[data-ac-contact-hp]');
  var phoneInput = fields.querySelector('[data-ac-phone]');

  var messages = {
    required: fields.dataset.msgRequired,
    email: fields.dataset.msgEmail,
    phone: fields.dataset.msgPhone,
    tooShort: fields.dataset.msgTooShort
  };

  // Deliberately loose: the only thing worth rejecting client-side is a typo
  // like a missing @ or dot. Anything stricter starts refusing valid addresses.
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  var iti = null;
  var validateOnInput = false;

  /* ── intl-tel-input ── */

  if (phoneInput && window.intlTelInput) {
    var utilsUrl = phoneInput.dataset.utilsUrl;
    iti = window.intlTelInput(phoneInput, {
      initialCountry: phoneInput.dataset.initialCountry || 'de',
      countryOrder: ['de', 'at', 'ch'],
      separateDialCode: true,
      strictMode: true,
      loadUtils: utilsUrl ? function () { return import(utilsUrl); } : undefined,
      countryNameLocale: 'de',
      uiTranslations: {
        selectedCountryAriaLabel: 'Land der Telefonnummer ändern, ausgewählt ${countryName} (${dialCode})',
        noCountrySelected: 'Land der Telefonnummer auswählen',
        countryListAriaLabel: 'Liste der Länder',
        searchPlaceholder: 'Suchen',
        clearSearchAriaLabel: 'Suche löschen',
        searchEmptyState: 'Keine Suchergebnisse'
      }
    });
  }

  /* ── Field validation ── */

  function fieldOf(input) {
    return input.closest('.ac-contact__field');
  }

  function showError(input, message) {
    var field = fieldOf(input);
    if (!field) return;
    var slot = field.querySelector('[data-ac-error]');
    if (slot) slot.textContent = message;
    field.classList.add('ac-contact__field--invalid');
    input.setAttribute('aria-invalid', 'true');
  }

  function clearError(input) {
    var field = fieldOf(input);
    if (!field) return;
    var slot = field.querySelector('[data-ac-error]');
    if (slot) slot.textContent = '';
    field.classList.remove('ac-contact__field--invalid');
    input.removeAttribute('aria-invalid');
  }

  function validateField(input) {
    var value = (input.value || '').trim();
    var isRequired = input.dataset.acRequired === 'true';
    var minLength = parseInt(input.dataset.acMinlength || '0', 10);

    if (isRequired && !value) {
      showError(input, messages.required);
      return false;
    }

    if (input === phoneInput) {
      // Optional field: empty is fine, but a typed number must be dialable.
      if (value && iti && typeof iti.isValidNumber === 'function' && iti.isValidNumber() === false) {
        showError(input, messages.phone);
        return false;
      }
      clearError(input);
      return true;
    }

    if (value && input.type === 'email' && !EMAIL_RE.test(value)) {
      showError(input, messages.email);
      return false;
    }

    if (value && minLength && value.length < minLength) {
      showError(input, messages.tooShort.replace('MIN', minLength));
      return false;
    }

    clearError(input);
    return true;
  }

  function validatableFields() {
    return Array.prototype.slice.call(fields.querySelectorAll('[data-ac-validate]'));
  }

  function validateAll() {
    var firstInvalid = null;
    validatableFields().forEach(function (input) {
      if (!validateField(input) && !firstInvalid) firstInvalid = input;
    });
    if (firstInvalid) {
      firstInvalid.focus({ preventScroll: true });
      firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    return !firstInvalid;
  }

  validatableFields().forEach(function (input) {
    input.addEventListener('blur', function () {
      if (validateOnInput) validateField(input);
    });
    input.addEventListener('input', function () {
      if (validateOnInput) validateField(input);
    });
  });

  /* ── Submit ── */

  function setBusy(busy) {
    if (!submitBtn) return;
    submitBtn.disabled = busy;
    submitBtn.classList.toggle('is-busy', busy);
  }

  function showThanks() {
    fields.hidden = true;
    thanks.hidden = false;
    thanks.classList.add('is-visible');
    thanks.focus({ preventScroll: true });
    thanks.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  // Shopify's spam protection hooks this form's submit event and injects an
  // hCaptcha token before the POST goes out. Submitting over fetch would race
  // that token, so the POST stays native and the thank-you state is rendered
  // server-side on the redirect back.
  form.addEventListener('submit', function (event) {
    validateOnInput = true;

    if (!validateAll()) {
      event.preventDefault();
      return;
    }

    // Bots fill every input; humans never see the honeypot. Drop it silently.
    if (honeypot && honeypot.value) {
      event.preventDefault();
      showThanks();
      return;
    }

    // Ship E.164 so the inbox gets a dialable number, not "0731 790308".
    if (iti && phoneInput && phoneInput.value.trim()) {
      phoneInput.value = iti.getNumber();
    }

    setBusy(true);
  });

  if (!thanks.hidden) {
    thanks.focus({ preventScroll: true });
    thanks.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
})();
